import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import "./ClockInStats.scss";
import { iconPicker } from "./iconPicker";
import { HollowDotsSpinner } from "react-epic-spinners";
import { selectTodayEmployeeIds } from "../../../selectors/todayClockings";

const NoClockIn = () => {
  const { eligibleEmployeesClockIn } = useSelector(
    (state) => state.employeesList
  );
  const { isDarkMode } = useSelector((state) => state.usersList);
  const { clockings } = useSelector((state) => state.clockings);
  const todayEmployeeIds = useSelector(selectTodayEmployeeIds);

  const missedClockIns = useMemo(() => {
    if (!clockings?.length || !eligibleEmployeesClockIn?.length) {
      return [];
    }
    return eligibleEmployeesClockIn.filter(
      (el) => !todayEmployeeIds.has(el?.employeeId)
    );
  }, [clockings, eligibleEmployeesClockIn, todayEmployeeIds]);

  return (
    <>
      {!!eligibleEmployeesClockIn && !!clockings ? (
        <div className={`no-clockin-container ${isDarkMode ? "dark" : ""}`}>
          {missedClockIns?.map((dco) => {
            return (
              <div className="dep-icon" key={dco?.employeeId}>
                <div
                  key={dco?.employeeId}
                  className="dep-icon-text"
                  style={{ width: "40%" }}
                >
                  {dco?.employeeFirstName + " " + dco?.employeeLastName}
                </div>

                <div
                  style={{
                    width: "60%",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  {iconPicker(
                    dco?.employeeDepartmentName,
                    isDarkMode ? "#e6e6e6" : "#323338"
                  )}
                  <div className="dep-icon-text">
                    {dco.employeeDepartmentName}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <HollowDotsSpinner color="#1da193" size={24} />
        </div>
      )}
    </>
  );
};

export default NoClockIn;
